(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SLogin", [], factory);
	else if(typeof exports === 'object')
		exports["SLogin"] = factory();
	else
		root["SLogin"] = factory();
})(window, function() {
return 